<template>
    <div class="reference-button">
        <button class="reference-information-btn" :class="{'reference-information-btn_has-footer': hasFooter}" @click.stop="openReferenceInformation">
            <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#508aff"><icon-faq /></icon-base>
        </button>

        <reference-information-dialog :content="content" :title="title" :hintsCode="hintsCode"/>
    </div>
</template>

<script>
import ReferenceInformationDialog from '@/components/Dialogs/ReferenceInformationDialog.vue';
import dialog from '@/mixins/dialog';

export default {
    props: {
        hasFooter: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Справка'
        },
        hintsCode: {
            type: String,
            default: ''
        },
    },
    mixins: [ dialog ],
    components: {
        ReferenceInformationDialog
    },
    methods: {
        openReferenceInformation() {
            this.elDialogs.referenceInformation = true
        },
    }
}
</script>